import Splide from '@splidejs/splide'

document.addEventListener('DOMContentLoaded', () => {
  const splideElement = document.querySelector('.single-player__other-player')

  if (splideElement) {
    const splide = new Splide('.splide-block-player', {
      perPage: 3,
      gap: '30px',
      arrows: false,
      drag: 'free',
      pagination: false,
      breakpoints: {
        992: {
          perPage: 2,
          gap: '15px',
        },
        767: {
          perPage: 1,
        },
      },
    })

    splide.mount()
  }
})
